import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {H6, Paragraph} from '@modifi/ui'
import {DefaultComponentWrapper} from '../common'
import {ImageSliderContainer, ImageCard, ImageCardContent} from './styles'

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      headline: PropTypes.string,
      subHeadline: PropTypes.string,
      description: PropTypes.string,
    }).isRequired
  ),
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  cards: [],
  backgroundColor: undefined,
}

export type ImageSliderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const ImageSlider: React.FC<ImageSliderProps> = ({cards, backgroundColor}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <ImageSliderContainer>
      {cards?.map((card, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <ImageCard key={`ImageSlider-card-${i}`}>
          <img src={card?.image} alt={card?.headline || ''} />
          <ImageCardContent>
            <H6 color="inherit">
              {card?.headline}
              <br />
              {card?.subHeadline}
            </H6>
            <Paragraph color="inherit">{card?.description}</Paragraph>
          </ImageCardContent>
        </ImageCard>
      ))}
    </ImageSliderContainer>
  </DefaultComponentWrapper>
)

ImageSlider.propTypes = propTypes

ImageSlider.defaultProps = defaultProps

export default ImageSlider
